// extracted by mini-css-extract-plugin
export default {"gototop":"Footer_gototop__Z9X6C","footer":"Footer_footer__UKNwF","anchortag":"Footer_anchortag__GD7SN","hidden123":"Footer_hidden123__oafD1","hiddentop":"Footer_hiddentop__dYXms"};